import React, { PureComponent } from 'react';
import { object, array, oneOfType } from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import { iFMessage, FMessage } from '../../hoc/IntlComponents';
import CardCollapsible from '../Card/CardCollapsible';
import { _toFixed } from '../../utils/utils';

const propTypes = {
  items: oneOfType([object, array]).isRequired,
  intl: intlShape.isRequired,
};

const defaultProps = {
  items: {},
};

class OfferGeoPrices extends PureComponent {
  getPrice = (price, curr) => {
    if (price === 0) {
      return <FMessage id="main.free" defaultMessage="Free" />;
    } else if (!price) {
      return null;
    }
    const factionalValue = price.toString().split('.');
    const isFraction = !isNaN(Number(factionalValue[1])) && Number(factionalValue[1]) > 0;
    const formatParam = isFraction ? '0,0.00' : '0,0';

    return (
      <span>
        {numeral(price).format(formatParam)} {curr}
      </span>
    );
  };

  getItems = () => {
    const { items, countries } = this.props;
    if (!items.countrys || !items.countrys.length) {
      return [<FMessage id="offer.geo-prices.no-limits" />];
    }
    return items.countrys.map((geo, index) => {
      const countryLabel = countries.find(country => country.id === geo);
      const price = get(items, `prices.${geo}.price`);
      const currency = get(items, `prices.${geo}.currency`);

      return (
        <div className="offer-geo-prices-item" key={geo}>
          <span className="offer-geo-prices-item_country mr-1">{countryLabel.title}</span>
          <span>{this.getPrice(price, currency)}</span>
        </div>
      );
    });
  };

  getControls = () => {
    const { offerId, withoutControls } = this.props;
    return [
      <Link
        key="request_offer_geo_link"
        to={`/tickets/create?theme=geoRequest&offer=${offerId}`}
        className={withoutControls ? '' : 'btn btn-primary btn-sm'}
      >
        <FormattedMessage id="offer.buttons.geo-request" defaultMessage="Not enough GEO?" />
      </Link>,
    ];
  };

  render() {
    const { intl, inPopup, collapsing, offerId, withoutControls } = this.props;

    const items = this.getItems();

    if (inPopup) {
      return <div className="offer-geo-prices in_popup">{items}</div>;
    }
    return (
      <CardCollapsible
        collapsing={collapsing}
        alwaysVisibleItem={withoutControls && this.getControls()}
        className="offer-geo-prices"
        title={iFMessage({ intl, id: 'offer.geo-prices.title' })}
        label={iFMessage({ intl, id: 'offer.geo.show-all' })}
        items={items}
        visibleItems={3}
        controls={withoutControls ? [] : this.getControls()}
      />
    );
  }
}

OfferGeoPrices.propTypes = propTypes;
OfferGeoPrices.defaultProps = defaultProps;

export default injectIntl(OfferGeoPrices);
